import { render, staticRenderFns } from "./BankReceiptsEditModal.vue?vue&type=template&id=c0f5b660&scoped=true"
import script from "./BankReceiptsEditModal.vue?vue&type=script&lang=js"
export * from "./BankReceiptsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f5b660",
  null
  
)

export default component.exports